import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import {
  loadUserCurrentSubscriptionApi,
  loadUserCurrentSubscriptionApiSuccess,
  loadUserCurrentSubscriptionApiFailure,
} from "./plan.actions";
import { of, catchError } from "rxjs";
import { map, filter, exhaustMap } from "rxjs/operators";
import { StripeService } from "../../core-services/services/stripe.service";
import { Store } from "@ngrx/store";
import { PlanState, initialPlanState } from "./plan.reducer";
import { selectPlanState } from "./plan.selectors";

interface AppState {
  plan: PlanState;
}

@Injectable()
export class PlanEffects {
  loadCurrentPlan$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUserCurrentSubscriptionApi),
      concatLatestFrom(() => this.store.select(selectPlanState)),
      filter(([action, planState]) => action?.refetchFromApi || !planState.loading || planState.data === null),
      exhaustMap(() =>
        this.stripeService.getCurrentPlan().pipe(
          map((data) => loadUserCurrentSubscriptionApiSuccess({ payload: data })),
          catchError((error) => of(loadUserCurrentSubscriptionApiFailure({ error: error?.message ?? error })))
        )
      )
    )
  );

  constructor(private actions$: Actions, private stripeService: StripeService, private store: Store<AppState>) {}
}
